<template>
  <div v-if="items && items.length" class="u-documents__docs">
    <div
      v-for="(item, idx) in items"
      :key="`acc-docs-${idx}`"
      class="u-documents__col p1-medium"
    >
      <a
        :href="item.src"
        class="ui-link _icon"
        target="_blank"
      >{{item.description}}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableDocsTemplate',
  props: {
    items: {
      type: Array,
      default() {
        return [];
      }
    }
  }
}
</script>